import {makeAutoObservable, runInAction} from 'mobx';
import {makeLoggable} from 'mobx-log';

import {AirtableFeedItem} from '../models/airtable';
import apiService from '../transport/apiService';

import type {RootStore} from './rootStore';

export class FeedStore {
  rootStore: RootStore;

  feedList: AirtableFeedItem[] = [];
  discoverList: AirtableFeedItem[] = [];

  segments: any[] = [];
  selectedSegment: any = 'ALL';

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
    makeLoggable(this);
  }

  getSegments = async (storeNumber?: string, storeState?: string) => {
    const selectedStore = this.rootStore.shopSelectionStore?.selectedStore;

    let finalStoreNumber = storeNumber;
    let finalStoreState = storeState;

    if (!finalStoreNumber) {
      finalStoreNumber = selectedStore?.store_number;
    }
    if (!finalStoreState) {
      finalStoreState =
        selectedStore?.address?.administrative_area?.toUpperCase();
    }

    if (!finalStoreNumber || !finalStoreState) {
      console.log('No store number or state, cannot load feed list');
      return;
    }

    apiService.getSegments(finalStoreNumber, finalStoreState).then(response => {
      runInAction(() => {
        const discover = {value: 'ALL', label: 'ALL'};
        this.segments = [
          discover,
          ...(response || []).map((seg: any) => ({value: seg, label: seg})),
        ];
        this.selectedSegment = discover;
      });
    });
  };

  selectSegment = (segment: any) => {
    this.selectedSegment = segment;
  };

  setFeedList = (list: any) => (this.feedList = list);
  setDiscoverList = (list: any) => (this.discoverList = list);

  getDiscoverList = () => {
    return this.selectedSegment.value === 'ALL'
      ? this.discoverList
      : this.discoverList.filter(
          (d: any) => d.segment === this.selectedSegment.value,
        );
  };

  async loadFeedList(storeNumber?: string, storeState?: string) {
    const selectedStore = this.rootStore.shopSelectionStore?.selectedStore;

    let finalStoreNumber = storeNumber;
    let finalStoreState = storeState;

    if (!finalStoreNumber) {
      finalStoreNumber = selectedStore?.store_number;
    }
    if (!finalStoreState) {
      finalStoreState =
        selectedStore?.address?.administrative_area?.toUpperCase();
    }

    if (!finalStoreNumber || !finalStoreState) {
      console.log('No store number or state, cannot load feed list');
      return;
    }

    // Split the feed list into dates for feed and all for discover.
    const date = new Date();
    const today = `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

    let data: any;
    try {
      data = await apiService.getFeedList(finalStoreNumber, finalStoreState);
      const feedData = data.filter(
        (item: any) => item.start <= today && item.end >= today,
      );
      const isNotExpired = (item: any) =>
        item.postEnd ? item.postEnd >= today : true;
      const discoverData = data.filter(
        (item: any) => item.postStart <= today && isNotExpired(item),
      );

      runInAction(() => {
        this.setDiscoverList(discoverData);
        this.setFeedList(feedData);
      });
    } catch (err) {
      console.log('Error loading feed list', err);
    }
  }

  loadLinkedProducts = async (article: any) => {
    if (article.productBarcodes?.length > 0) {
      return await apiService.searchByBarcode(article.productBarcodes);
    } else {
      return [];
    }
  };
}
